export default __webpack_public_path__ + "static/media/LastPageCover.f011454e.png";